import { FieldType } from '../types';

/**
 * Maps frontend field types to backend field types
 * This ensures compatibility with the backend API
 */
export const mapFieldTypeToBackend = (fieldType: FieldType): FieldType => {
  // Field types are already in the correct format for backend
  return fieldType;
};

/**
 * Gets the display label for a field type
 */
export const getFieldTypeLabel = (fieldType: FieldType): string => {
  const labels: Record<FieldType, string> = {
    'text': 'Text',
    'number': 'Number',
    'single-choice': 'Single Choice',
    'multi-choice': 'Multi Choice',
    'url': 'URL',
    'date': 'Date',
    'boolean': 'Boolean',
    'email': 'Email',
    'phone': 'Phone',
  };
  return labels[fieldType] || fieldType;
};
